export default __webpack_public_path__ + "static/media/Iceland-7.755f4b94.webp";